module.exports = ["article","header","aside","hgroup","blockquote","hr","iframe","body","li","map","button","object","canvas","ol","caption","output","col","p","colgroup","pre","dd","progress","div","section","dl","table","td","dt","tbody","embed","textarea","fieldset","tfoot","figcaption","th","figure","thead","footer","tr","form","ul","h1","h2","h3","h4","h5","h6","video","script","style"]


//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/block-elements.json
// module id = 649
// module chunks = 168707334958949